import { logAnalyticEvent } from '.';

export const logUserNetworkData = () => {
  if ('connection' in navigator) {
    const connection = navigator.connection as any;

    logAnalyticEvent('webapp_user_network_data', {
      effectiveType: connection.effectiveType, // 4g, 3g, 2g, slow-2g
      downlink: connection.downlink, // Connection bandwidth in Mbps
      roundTripTime: connection.rtt, // Network latency in ms
      userAgent: navigator.userAgent // Browser details
    });
  }
};
